import React from "react";
import DashboardSection from "./../components/DashboardSection";

function DashboardPage(props) {
  return (
    <DashboardSection
      bgColor="default"
      size="medium"
      bgImage=""
      bgImageOpacity={1}
      title="Dashboard"
      subtitle=""
    />
  );
}

export default DashboardPage;
